import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CityConfigService } from '@app/core/services';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs';

import { AllowedRoutes } from '../city-configs/city-configs';

@Injectable({
    providedIn: 'root',
})
export class DefaultRouteService {
    private cityConfigService = inject(CityConfigService);
    private router = inject(Router);

    navigateToDefaultRouteUrlTree(): Observable<UrlTree> {
        return this.cityConfigService.getAllowedRoutes().pipe(
            filter((allowedRoutes) => allowedRoutes.length > 0),
            take(1),
            map((allowedRoutes) => {
                const routeGenerateVoucherIsAllowed = allowedRoutes.includes(AllowedRoutes.GENERATE_VOUCHER);
                const routeStatisticsIsAllowed = allowedRoutes.includes(AllowedRoutes.STATISTICS);
                if (routeGenerateVoucherIsAllowed) {
                    return this.router.createUrlTree(['dashboard', AllowedRoutes.GENERATE_VOUCHER]);
                }
                if (routeStatisticsIsAllowed) {
                    return this.router.createUrlTree(['dashboard', AllowedRoutes.STATISTICS]);
                }
                return this.router.createUrlTree(['auth', 'login']);
            }),
        );
    }
    navigateToDefaultRoute(): void {
        this.navigateToDefaultRouteUrlTree()
            .pipe(take(1))
            .subscribe((tree: UrlTree) => {
                this.router.navigateByUrl(tree.toString());
            });
    }
}
